import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withTranslate from '../../hoc/with-translate';
import styles from './message.scss';

const Message = ({ alignment, type, content, onClose, top, t }) => {
  const isDefaultStyle = !type;
  const containerClassName = classNames(
    styles.container,
    styles[type],
    styles[alignment],
    {
      'forum-card-color': isDefaultStyle,
      'icon-secondary-background-color': isDefaultStyle,
    },
    'message'
  );
  const style = {
    top: `${top}px`,
  };

  if (typeof content !== 'function') {
    const element = content;
    content = () => React.Children.only(element);
  }

  return (
    <div className={containerClassName} style={style}>
      {content(t)}
      {onClose && <button className={classNames(styles.close, 'message__close')} onClick={onClose}/>}
    </div>
  );
};

Message.propTypes = {
  onClose: PropTypes.func,
  type: PropTypes.string.isRequired,
  content: PropTypes.any,
  alignment: PropTypes.string,
  top: PropTypes.number,
  t: PropTypes.func,
};

Message.defaultProps = {
  top: 0,
  content: null,
};

export default withTranslate(Message);



// WEBPACK FOOTER //
// ./app/components/message/message.js